import LinkType from "%/dynamic-component-editor/options/link-type";
import {
  resolveContextEntityHref,
  resolveUriVarsHref,
} from "%/dynamic-component-editor/standard-elements/click-actions/resolve-context-href";

// A page slug can carry uri placeholders ("program_category/{story_id}") that
// only the click action's contextSource fills — otherwise they reach the URL raw.
export const ContextHrefMixin = {
  inject: {
    scopedProvidedContexts: {
      from: "scopedProvidedContexts",
      default: null,
    },
    pageEntities: {
      from: "pageEntities",
      default: null,
    },
    inBuilderEditScope: {
      from: "inBuilderEditScope",
      default: false,
    },
  },
  methods: {
    contextResolvedHref(action, urlValue, webBase) {
      if (action?.linkType !== LinkType.LINK_TYPE_PAGE) {
        return null;
      }
      const uriVarSources = action?.uriVarSources;
      const hasPerVar = uriVarSources && Object.keys(uriVarSources).length > 0;
      if (!hasPerVar && !action?.contextSource) {
        return null;
      }
      const quiet = Boolean(typeof this.inBuilderEditScope === "function"
        ? this.inBuilderEditScope()
        : this.inBuilderEditScope);
      if (hasPerVar) {
        return resolveUriVarsHref(
          uriVarSources, action.contextSource, urlValue, webBase, this.scopedProvidedContexts, this.pageEntities, { quiet },
        );
      }
      return resolveContextEntityHref(
        action.contextSource, urlValue, webBase, this.scopedProvidedContexts, this.pageEntities, { quiet },
      );
    },
  },
};

export default ContextHrefMixin;
